import {TOption} from './TOption'

export const FINANCIAL_DOC_STATUS: TOption[] = [
  {value: '1', label: 'Dikirimkan'},
  {value: '2', label: 'Revisi'},
  {value: '3', label: 'Ditinjau'},
  {value: '4', label: 'Dikirimkan ke Finance'},
  {value: '5', label: 'Valid'},
  {value: '6', label: 'Menunggu Findoc'},
  {value: '13', label: 'SAP Error'},
  {value: '90', label: 'Expired'},
  {value: '99', label: 'Ditolak'},
]
